import { render, staticRenderFns } from "./FlagshipProfilingStepBudgetVideo.vue?vue&type=template&id=fe400c1a&"
import script from "./FlagshipProfilingStepBudgetVideo.vue?vue&type=script&lang=ts&"
export * from "./FlagshipProfilingStepBudgetVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports